/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Import200ResponseDataInner
 */
export interface Import200ResponseDataInner {
  /**
   * Номер класса МКТУ
   * @type {number}
   * @memberof Import200ResponseDataInner
   */
  classNumber: number
  /**
   * Фразы класса из файла
   * @type {Array<string>}
   * @memberof Import200ResponseDataInner
   */
  selectedWords: Array<string>
}

/**
 * Check if a given object implements the Import200ResponseDataInner interface.
 */
export function instanceOfImport200ResponseDataInner(
  value: object
): value is Import200ResponseDataInner {
  if (!('classNumber' in value) || value['classNumber'] === undefined)
    return false
  if (!('selectedWords' in value) || value['selectedWords'] === undefined)
    return false
  return true
}

export function Import200ResponseDataInnerFromJSON(
  json: any
): Import200ResponseDataInner {
  return Import200ResponseDataInnerFromJSONTyped(json, false)
}

export function Import200ResponseDataInnerFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Import200ResponseDataInner {
  if (json == null) {
    return json
  }
  return {
    classNumber: json['classNumber'],
    selectedWords: json['selectedWords'],
  }
}

export function Import200ResponseDataInnerToJSON(
  value?: Import200ResponseDataInner | null
): any {
  if (value == null) {
    return value
  }
  return {
    classNumber: value['classNumber'],
    selectedWords: value['selectedWords'],
  }
}
